import React, { useState } from 'react';
import { ConstructorEventUpdateSQLStatus } from '../../../../Event/event';

const ResourceAdventures = () => {
  const [screen, setScreen] = useState('landing');
  const [gameData, setGameData] = useState({});
  const [answer, setAnswer] = useState('');
  const [result, setResult] = useState('');

  const randomMultiple = (min, max, step) => {
    const low = Math.ceil(min / step);
    const high = Math.floor(max / step);
    return step * (Math.floor(Math.random() * (high - low + 1)) + low);
  };

  const startGame = (name, unit, color1, color2) => {
    const step = [4, 6, 8, 10][Math.floor(Math.random() * 4)];
    const total = randomMultiple(60, 150, step);
    setGameData({ name, unit, color1, color2, step, total, current: total, turns: 0 });
    setResult('');
    setScreen('game');
  };

  const updateAnswer = (e) => {
    setAnswer(e.target.value);
  };

  const checkAnswer = () => {
    const userAnswer = parseInt(answer);
    const correctAnswer = Math.max(gameData.current - gameData.step, 0);
    if (userAnswer === correctAnswer) {
      const newCurrent = correctAnswer;
      const newTurns = gameData.turns + 1;
      if (newCurrent === 0) {
        setResult(`🎉 You did it in ${newTurns} turns!`);
           const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
      } else {
        setResult('👍 Correct!');
      }
      setGameData({ ...gameData, current: newCurrent, turns: newTurns });
    } else {
      setResult('❌ Oops, try again!');
    }
    setAnswer('');
  };

  const restart = () => {
    setScreen('landing');
    setAnswer('');
    setResult('');
  };

  const percent = (gameData.current / gameData.total) * 100;

  return (
    <div style={{ fontFamily: 'Comic Sans MS, Segoe UI, cursive', background: 'linear-gradient(to bottom, #e1f5fe, #b3e5fc)', minHeight: '100vh', padding: '1rem', textAlign: 'center' }}>
      <style>
        {`
          @media (max-width: 600px) {
            .card { width: 90% !important; }
            .theme-container { gap: 20px !important; }
            input[type="number"] { width: 80px !important; }
            button { font-size: 1rem !important; padding: 8px 16px !important; }
          }
        `}
      </style>
      {screen === 'landing' && (
        <>
          <h1 style={{ fontSize: '2.5rem', margin: '30px 0' }}>🎮 Resource Adventures!</h1>
          <p className="mascot" style={{ fontSize: '1.2rem', color: '#5e35b1' }}>👋 Hey buddy! Pick your challenge below:</p>
          <div className="theme-container" style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '30px', marginTop: '30px' }}>
            {[
              { name: 'Water', unit: 'liters', color1: '#81d4fa', color2: '#4fc3f7', emoji: '💧', desc: 'Empty the tower by solving each step!' },
              { name: 'Ice', unit: 'blocks', color1: '#b3e5fc', color2: '#81d4fa', emoji: '🧊', desc: 'Melt the ice with your brain power!' },
              { name: 'Dirt', unit: 'chunks', color1: '#ffe082', color2: '#ffca28', emoji: '💎', desc: 'Dig your way to treasure by thinking!' },
            ].map(({ name, unit, color1, color2, emoji, desc }) => (
              <div
                key={name}
                className="card"
                onClick={() => startGame(name, unit, color1, color2)}
                style={{ background: '#fffde7', border: '4px dashed #fdd835', borderRadius: '20px', width: '280px', padding: '25px', cursor: 'pointer', transition: 'transform 0.3s ease', boxShadow: '0 6px 12px rgba(0,0,0,0.1)' }}
              >
                <h2 style={{ fontSize: '1.7rem', margin: '0' }}>{emoji} {name} Challenge</h2>
                <p style={{ fontSize: '1rem', color: '#616161' }}>{desc}</p>
              </div>
            ))}
          </div>
        </>
      )}

      {screen === 'game' && (
        <div style={{ maxWidth: '600px', margin: 'auto' }}>
          <h2 style={{ fontSize: '2rem', margin: '20px 0 10px' }}>{gameData.name} Challenge 🎯</h2>
          <p>Start: {gameData.total} {gameData.unit} | Step: {gameData.step} {gameData.unit}</p>
          <div style={{ margin: '20px auto', width: '120px', height: '300px', border: '4px solid #004d40', borderRadius: '20px', background: `linear-gradient(to top, ${gameData.color1}, ${gameData.color2})`, position: 'relative', overflow: 'hidden' }}>
            <div style={{ position: 'absolute', bottom: 0, width: '100%', height: `${percent}%`, background: 'linear-gradient(to top, #ffcc80, #ffa726)', borderRadius: '0 0 16px 16px', transition: 'height 0.8s ease' }} />
          </div>
          <div style={{ fontSize: '1.3rem', margin: '15px' }}>Turn {gameData.turns + 1}: What is {gameData.current} - {gameData.step}?</div>
          <input type="number" value={answer} onChange={updateAnswer} placeholder="Type answer" style={{ padding: '8px', fontSize: '1.2rem', width: '200px', borderRadius: '10px', border: '2px solid #81d4fa', marginTop: '15px', margin:"0 auto" }} />
          <br />
          <button onClick={checkAnswer} style={{ fontSize: '1.2rem', marginTop: '10px', borderRadius: '12px', border: 'none', background: '#64b5f6', color: 'white', cursor: 'pointer', padding: '10px 20px', boxShadow: '0 4px #1976d2' }}>✅ Submit</button>
          <div style={{ fontSize: '1.3rem', margin: '15px', color: result.includes('Correct') || result.includes('did it') ? 'green' : 'red' }}>{result}</div>
          <button onClick={restart} style={{ fontSize: '1.2rem', marginTop: '10px', borderRadius: '12px', border: 'none', background: '#64b5f6', color: 'white', cursor: 'pointer', padding: '10px 20px', boxShadow: '0 4px #1976d2' }}>🔙 Back</button>
        </div>
      )}
    </div>
  );
};

export default ResourceAdventures;
